export default __webpack_public_path__ + "static/media/virus_icon_white_mob.0fa6724b.png";